import { render, staticRenderFns } from "./GSelectCurso.vue?vue&type=template&id=eb4768ec"
import script from "./GSelectCurso.vue?vue&type=script&lang=js"
export * from "./GSelectCurso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports